import { useEffect } from 'react';

import { usePerspectiveColor } from './usePerspectiveColor';
import { usePerspectiveFavicon } from './usePerspectiveFavicon';

/**
 * Mirrors the active perspective color to `data-perspective` on <html>,
 * which switches the `perspective-*` color tokens (see index.css),
 * and keeps the favicon in sync with the active perspective.
 */
export function PerspectiveTheme() {
  const color = usePerspectiveColor();
  const favicon = usePerspectiveFavicon();

  useEffect(() => {
    document.documentElement.dataset.perspective = color;
  }, [color]);

  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (link) link.href = favicon;
  }, [favicon]);

  return null;
}
